module.exports = __webpack_public_path__ + "static/media/food app.5bd044d5.jpg";